<script lang="ts">
	let className = '';
	export { className as class };
</script>

<div class={`lds-ellipsis ${className}`}>
	<div></div>
	<div></div>
	<div></div>
	<div></div>
</div>

<style lang="scss">
	@import 'loader';
</style>
